import { Col, Label, Row } from "reactstrap";

import React from "react";
import Select from "../../Common/AppSelect";

export function TabAcquisitionChannel({
  activeVerticalTab,
  handleCheckEachStep,
  acquisitionChannelListAPI,
  customerDetails,
  setCustomerDetails,
}) {
  return (
    <>
      <div>
        <h5>Acquisition Channel</h5>
      </div>

      <Row className="g-3">
        <Col lg={12}>
          <div>
            <div className={"pt-4"}>
              <Label for="paymentTerms">Select acquisition channel</Label>
              <Select
                options={
                  acquisitionChannelListAPI
                    ? acquisitionChannelListAPI?.map((item) => ({
                        value: item.Id,
                        label: item.Name,
                        id: item.Id,
                      }))
                    : []
                }
                onChange={(e) => {
                  setCustomerDetails({
                    ...customerDetails,
                    CustomerAcquisitionChannel_Id: e?.value,
                  });
                }}
                value={{
                  value: customerDetails?.CustomerAcquisitionChannel_Id,
                  label: acquisitionChannelListAPI?.find(
                    (item) =>
                      item.Id === customerDetails?.CustomerAcquisitionChannel_Id
                  )?.Name,
                  id: customerDetails?.CustomerAcquisitionChannel_Id,
                }}
                className="form-control"
              ></Select>
            </div>
            <div className={"pt-2"}>
              <Label>Notes</Label>
              <textarea
                className="form-control"
                rows="3"
                value={customerDetails?.Notes}
                onChange={(e) => {
                  setCustomerDetails({
                    ...customerDetails,
                    Notes: e.target.value,
                  });
                }}
              ></textarea>
            </div>
          </div>
        </Col>
      </Row>

      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-light btn-label previestab"
          onClick={() => {
            handleCheckEachStep(activeVerticalTab - 1);
          }}
        >
          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>{" "}
          People
        </button>
        <button
          type="button"
          className="btn btn-success btn-label right ms-auto nexttab"
          onClick={() => {
            handleCheckEachStep(activeVerticalTab + 1);
          }}
        >
          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          Additional Info
        </button>
      </div>
    </>
  );
}
